import React from "react";

const activeStyle = {
  border: "1px solid #7dd3fc",
  background: "rgba(14, 165, 233, 0.16)",
  color: "inherit",
  borderRadius: 10,
  padding: "6px 10px",
  cursor: "pointer",
};

const inactiveStyle = {
  border: "1px solid rgba(255,255,255,0.35)",
  background: "rgba(255,255,255,0.04)",
  color: "inherit",
  borderRadius: 10,
  padding: "6px 10px",
  cursor: "pointer",
};

export default function ExplanationMethodTabs({
  title = "Wybierz sposób przekształcenia:",
  methods = [],
  initialKey,
}) {
  const [selectedKey, setSelectedKey] = React.useState(
    initialKey || methods[0]?.key || ""
  );
  const selected = methods.find((method) => method.key === selectedKey) || methods[0];

  if (!methods.length) return null;

  return (
    <div>
      {title && (
        <p>
          <strong>{title}</strong>
        </p>
      )}
      <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 18 }}>
        {methods.map((method) => (
          <button
            key={method.key}
            type="button"
            onClick={() => setSelectedKey(method.key)}
            style={method.key === selected?.key ? activeStyle : inactiveStyle}
          >
            {method.label}
          </button>
        ))}
      </div>
      {typeof selected?.content === "function" ? selected.content() : selected?.content}
    </div>
  );
}
